export class AppConfig {

   // url: string = 'http://127.0.0.1:8004/api/';
   // urlAAD:string = 'http://127.0.0.1:8004/saml2/aad/';

   url: string = 'https://sistemas.codhem.org.mx/back/public/api/';
   urlAAD:string = 'https://sistemas.codhem.org.mx/back/public/saml2/aad/';

}